import { ResetButton } from 'components/styles'
import React, { ButtonHTMLAttributes } from 'react'
import { VoidCallback } from 'types/index'
import { determineSize, IconSizes } from '../utils/determineSize'

type Props = IconSizes & {
	type?: ButtonHTMLAttributes<HTMLButtonElement>['type']
	onClick?: VoidCallback
}
//TODO: Make an IconComponent Type to better constrain these
export const IconButton: React.FC<React.PropsWithChildren<Props>> = ({
	children,
	onClick,
	type = 'button',
	...sizeProps
}) => {
	return (
		<ResetButton type={type} onClick={onClick} style={determineSize(sizeProps)}>
			{children}
		</ResetButton>
	)
}
